<template>
  <AppMenuAsPopover :card-min-width="286"
                    :card-max-width="286"
                    bottom
                    left
                    @menu-state-change="isMenuOpened = $event"
  >
    <template #activator="{ props }">
      <app-button
        type="outlined"
        variant="neutral"
        :height="28"
        v-bind="props"
      >
        {{ $t(`project.checklist.dialogs.SaveChecklistDialog.rightTypeOptions.${accessRight}.title`) }}
        <app-material-icon
          :name="isMenuOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
          class="ml-2"
          color="icon-secondary"
        />
      </app-button>
    </template>

    <template #default="{closeMenu}">
      <v-card-text class="text--primary pa-2">
        <div v-for="option in rightTypeOptionsValues"
             :key="`option-${option}`"
        >
          <v-divider v-if="option === RIGHT_TYPE_OPTIONS.REMOVE" class="my-1"></v-divider>
          <div class="d-flex pa-2 clickable rounded-lg"
               :class="option === RIGHT_TYPE_OPTIONS.REMOVE ? 'menu-item-remove' : 'menu-item'"
               @click="editUserRight(closeMenu, option)"
          >
            <div>
              <!-- Title -->
              <p :class="{ 'text-text-danger': option === RIGHT_TYPE_OPTIONS.REMOVE, 'text-text-secondary': option !== RIGHT_TYPE_OPTIONS.remove }"
                        class="mb-0 text--small text--bold"
              >
                {{ $t(`project.checklist.dialogs.SaveChecklistDialog.rightTypeOptions.${option}.title`) }}
              </p>
              <!-- subTitle -->
              <p v-if="option !== RIGHT_TYPE_OPTIONS.REMOVE"
                        class="mt-1 text--regular text--x-small text-text-tertiary"
              >
                {{ $t(`project.checklist.dialogs.SaveChecklistDialog.rightTypeOptions.${option}.subTitle`) }}
              </p>
            </div>
            <template v-if="option === accessRight">
              <app-material-icon
                name="check"
                size="sm"
                class="ml-2"
                color="icon-info"
              />
            </template>
          </div>
        </div>
      </v-card-text>
    </template>
  </AppMenuAsPopover>
</template>

<script>
  import AppMenuAsPopover from '@/common/AppMenuAsPopover.vue'
  import { RIGHT_TYPE_OPTIONS } from '@/common/utils/rightTypes.ts'

  export default {
    name: 'SaveChecklistShareRightsMenu',
    components: { AppMenuAsPopover },
    props: {
      userAccessRight: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        isMenuOpened: false,
        accessRight: this.userAccessRight,
        RIGHT_TYPE_OPTIONS,
      }
    },
    computed: {
      rightTypeOptionsValues () {
        return Object.values(RIGHT_TYPE_OPTIONS)
      },
    },
    methods: {
      editUserRight (closeMenuFunction, newRight) {
        this.accessRight = newRight
        this.$emit('set-user-rights', this.accessRight)
        closeMenuFunction()
      },
    },
  }
</script>

<style scoped lang="scss">
  .menu-item:hover {
    background-color: rgb(var(--v-theme-surface-hover));
  }
  .menu-item-remove:hover {
    background-color: rgb(var(--v-theme-surface-danger-subtle));
  }
</style>
